import { i as c } from "./modal.css-DWsl4ezd.js";
import { f as d } from "./first-focusable-in-C_FjNeTy.js";
import { M as m } from "./MatchMedia-D1Uy-Fr0.js";
import { i as p, x as l } from "./lit-element-6iugfgmM.js";
import { S as u } from "./Base-pdJ5fkYW.js";
import { n as y } from "./property-BWlAHqg_.js";
import { i as h } from "./query-D8_rwLua.js";
import { d as v } from "./define-element-Dl91r6Vu.js";
const b = p`
    :host{inline-size:100%;justify-content:center;display:flex;position:fixed;inset-block-end:0;inset-inline-start:0}.tray{--spectrum-tray-max-inline-size:var(--mod-tray-max-inline-size,375px);--spectrum-tray-spacing-edge-to-tray-safe-zone:var(--mod-tray-spacing-edge-to-tray-safe-zone,64px);--spectrum-tray-entry-animation-delay:var(--mod-tray-entry-animation-delay,.16s);--spectrum-tray-entry-animation-duration:var(--mod-tray-entry-animation-duration,var(--spectrum-animation-duration-500));--spectrum-tray-exit-animation-delay:var(--mod-tray-exit-animation-delay,0s);--spectrum-tray-exit-animation-duration:var(--mod-tray-exit-animation-duration,var(--spectrum-animation-duration-100));--spectrum-tray-corner-radius:var(--mod-tray-corner-radius,var(--spectrum-corner-radius-100));--spectrum-tray-background-color:var(--highcontrast-tray-background-color,var(--mod-tray-background-color,var(--spectrum-background-layer-2-color)));--mod-modal-max-width:100%;inline-size:100%;max-inline-size:100%;max-block-size:calc(100vh - 64px);max-block-size:calc(100vh - var(--spectrum-tray-spacing-edge-to-tray-safe-zone));box-sizing:border-box;border-radius:0;border-radius:var(--mod-tray-corner-radius-portrait,0)var(--mod-tray-corner-radius-portrait,0)0 0;transition:opacity var(--spectrum-tray-exit-animation-duration)cubic-bezier(.5,0,1,1)0s,visibility var(--spectrum-tray-exit-animation-duration)linear calc(var(--spectrum-tray-exit-animation-duration)),transform var(--spectrum-tray-exit-animation-duration)cubic-bezier(.5,0,1,1)0s;transition:opacity var(--spectrum-tray-exit-animation-duration)cubic-bezier(.5,0,1,1)var(--spectrum-tray-exit-animation-delay),visibility var(--spectrum-tray-exit-animation-duration)linear calc(var(--spectrum-tray-exit-animation-delay) + var(--spectrum-tray-exit-animation-duration)),transform var(--spectrum-tray-exit-animation-duration)cubic-bezier(.5,0,1,1)var(--spectrum-tray-exit-animation-delay);background-color:var(--spectrum-tray-background-color);outline:none;margin-block-start:var(--spectrum-tray-spacing-edge-to-tray-safe-zone);padding-block-start:var(--mod-tray-top-to-content-area,var(--spectrum-tray-top-to-content-area));padding-block-end:var(--mod-tray-bottom-to-content-area,var(--spectrum-tray-top-to-content-area));overflow:auto;transform:translateY(100%)}:host([open]) .tray{transition:transform var(--spectrum-tray-entry-animation-duration)cubic-bezier(0,0,.4,1)var(--spectrum-tray-entry-animation-delay),opacity var(--spectrum-tray-entry-animation-duration)cubic-bezier(0,0,.4,1)var(--spectrum-tray-entry-animation-delay);transform:translateY(0)}@media screen and (orientation:landscape){.tray{max-inline-size:var(--spectrum-tray-max-inline-size);border-start-start-radius:var(--spectrum-tray-corner-radius);border-start-end-radius:var(--spectrum-tray-corner-radius)}}@media (forced-colors:active){.tray{--highcontrast-tray-background-color:Canvas;border:solid}.tray ::slotted(*){border:none}}:host{max-height:100vh;max-height:100dvh;align-items:flex-end;position:fixed!important}sp-underlay{touch-action:none}.tray{overscroll-behavior:contain;display:inline-flex}::slotted(.visually-hidden){clip:rect(0,0,0,0);clip-path:inset(50%);height:1px;width:1px;white-space:nowrap;border:0;margin:0 -1px -1px 0;padding:0;position:absolute;overflow:hidden}
`;
var x = Object.defineProperty, s = (i, t, a, f) => {
  for (var n, r = void 0, e = i.length - 1; e >= 0; e--) (n = i[e]) && (r = n(t, a, r) || r);
  return r && x(t, a, r), r;
};
class o extends u {
  constructor() {
    super(...arguments), this.open = !1, this.prefersMotion = new m(this, "(prefers-reduced-motion: no-preference)"), this.transitionPromise = Promise.resolve(), this.resolveTransitionPromise = () => {
    }, this.animating = !1;
  }
  static get styles() {
    return [c, b];
  }
  focus() {
    const t = d(this);
    t ? t.focus() : this.children.length === 1 ? this.tray.focus() : super.focus();
  }
  overlayWillCloseCallback() {
    return this.open ? (this.close(), !0) : this.animating;
  }
  close() {
    this.open = !1, this.prefersMotion.matches || this.dispatchClosed();
  }
  dispatchClosed() {
    this.dispatchEvent(new Event("close", { bubbles: !0 }));
  }
  handleUnderlayTransitionend() {
    this.open || (this.resolveTransitionPromise(), this.dispatchClosed());
  }
  handleTrayTransitionend() {
    this.open && this.resolveTransitionPromise();
  }
  update(t) {
    t.has("open") && t.get("open") !== void 0 && this.prefersMotion.matches && (this.animating = !0, this.transitionPromise = new Promise((a) => {
      this.resolveTransitionPromise = () => {
        this.animating = !1, a();
      };
    })), super.update(t);
  }
  render() {
    return l`
            <sp-underlay
                ?open=${this.open}
                @close=${this.close}
                @transitionend=${this.handleUnderlayTransitionend}
            ></sp-underlay>
            <div
                class="tray modal"
                tabindex="-1"
                @transitionend=${this.handleTrayTransitionend}
            >
                <slot></slot>
            </div>
        `;
  }
  async getUpdateComplete() {
    const t = await super.getUpdateComplete();
    return await this.transitionPromise, t;
  }
}
s([y({ type: Boolean, reflect: !0 })], o.prototype, "open"), s([h(".tray")], o.prototype, "tray"), v("sp-tray", o);
//# sourceMappingURL=sp-tray-DmIoHTCc.js.map
